import styled from 'styled-components';

export const FormContainer = styled.div`
  padding: 16px;
`;

export const DragAndDropContainer = styled.div`
  margin-top: 16px;
`;
